module.exports = __webpack_public_path__ + "img/hr-grass-transition.70e56f3f.png";